// Localized path registry.
// Adding a new bilingual route? Add it here — ONE source of truth.
//
// Usage:
//   const { localizedPath, counterpartPath } = useLocalizedPaths();
//   const reg = localizedPath('register');            // → /kayit or /register
//   const other = counterpartPath('/kayit/blue-zone'); // → /register/blue-zone

export const PATH_MAP = {
  tr: {
    home:           '/',
    login:          '/giris',
    register:       '/kayit',
    blueZone:       '/kayit/blue-zone',
    greenZone:      '/kayit/green-zone',
    supplierRegister:  '/tedarikci-kayit',
    contractorRegister:'/yuklenci-kayit',
  },
  en: {
    home:           '/',
    login:          '/login',
    register:       '/registration',
    blueZone:       '/registration/blue-zone',
    greenZone:      '/registration/green-zone',
    supplierRegister:  '/supplier-register',
    contractorRegister:'/contractor-register',
  },
};

// Flat "any known localized URL" → canonical key map (used to find counterpart).
const URL_TO_KEY = Object.entries(PATH_MAP).reduce((acc, [lang, routes]) => {
  Object.entries(routes).forEach(([key, path]) => { acc[path] = key; });
  return acc;
}, {});

export const resolvePath = (lang, key) =>
  (PATH_MAP[lang] && PATH_MAP[lang][key]) || PATH_MAP.en[key] || '/';

export const findCounterpartPath = (currentPath, targetLang) => {
  if (!currentPath) return null;
  // Strip query/hash for matching
  const clean = currentPath.split('?')[0].split('#')[0];
  const key = URL_TO_KEY[clean];
  if (!key) return null;
  return resolvePath(targetLang, key);
};
